import React from 'react';
import { StyleSheet } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';
import { gradients } from '../theme/tokens';

/**
 * Fond des onglets Offres et Carrière : un dégradé vertical bleuté, posé sous le contenu.
 *
 * Décoratif : jamais touchable, ignoré des lecteurs d'écran. À placer en PREMIER enfant de l'écran,
 * le contenu venant par-dessus.
 */
export function FondAube() {
  return (
    <LinearGradient
      testID="fond-aube"
      colors={gradients.aube}
      start={{ x: 0.5, y: 0 }}
      end={{ x: 0.5, y: 1 }}
      pointerEvents="none"
      accessibilityElementsHidden
      importantForAccessibility="no-hide-descendants"
      style={StyleSheet.absoluteFill}
    />
  );
}
